









































import { Component, Vue, Prop, Emit, Watch } from 'vue-property-decorator';
import { uploadBrandImage } from '@/utils/api'; //上传LOGO图片
import { RuleFormAdd } from "../interface";
@Component
export default class upload extends Vue {
  loading:boolean=false;
  imgUrl:string='';//图片地址
  isshow:boolean=true;
  srcList:Array<string>=[];
  zIndex:number=9999;

  @Prop(Object)
  ruleForm!: RuleFormAdd;

  created () {
    if((this.ruleForm["brandId"])){
      this.imgUrl=this.ruleForm['imageUrl'];
      this.srcList.push(this.ruleForm['imageUrl'] as string);
      this.isshow=false;
    }else{
      this.isshow=true;
    }
  }
  @Watch('ruleForm',{ immediate: true, deep: true })
  onChildChanged(val: Object, oldVal: Object) {
    if(val["imageUrl"]){
      this.imgUrl=val["imageUrl"];
      this.srcList.push(this.ruleForm['imageUrl'] as string);
      this.isshow=false
    }else{
      this.isshow=true;
    }
  }
  // 上传图片过滤
  beforeAvatarUpload(file) {
    const isJPG = file.type === 'image/jpeg' ||  file.type === 'image/png';
    const isLt2M = file.size/1024/1024 < 2;
    if (!isJPG) {
      this.$message.error('上传Logo图片只能是 JPG 格式或是png格式!');
    }
    if (!isLt2M) {
      this.$message.error('上传Logo图片大小不能超过 2MB!');
    }
    return isJPG && isLt2M;
  }
  // 图片上传
  upload(param) {
    this.loading=true;
    const fromData = new FormData()
    fromData.append('file', param.file)
    uploadBrandImage(fromData).then((data:any) => {
      this.imgUrl = data.fileUrl;
      this.isshow=false;
      this.srcList=[];
      this.srcList.push(data.fileUrl as string);
      this.$emit('handleAvatarSuccess', data.fileUrl);
    }).finally(()=>{
      this.loading=false;
    });
  }
}
